module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_moducom.c022345d02fcc5f97a74b3f025a017fa.png";